function addToCart(_this, user, cartitem) {
  for (let rule of _this.pageData.discountRules) {
    if (rule.product_id == cartitem.productid) {
      cartitem.scount = rule.discount
      cartitem.disprice = cartitem.uniprice * (1 - cartitem.scount)
    }
  }

  let productList = []
  return new Promise((resolve, reject) => {
    getCartIndex(_this, user.username).then((val) => {
      if (val == -1) {
        cartitem.index = 0
      } else {
        cartitem.index = val + 1
      }
      if (_this.pageData.headMenu) {
        productList = _this.pageData.headMenu.itemInList.flatMap((item) =>
          (item.items || []).map(({ img, ...rest }) => rest)
        )
      }

      _this
        .$axios({
          method: 'post',
          // url: Vue.prototype.api + '6003/api/local/addToCart',
          url: Vue.prototype.api + 'api/local/addToCart',
          data: {
            user,
            cartitem,
            productList,
          },
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.code == '200') {
              //新增，加入购物车成功后更新用户信息
              let userData = JSON.parse(
                sessionStorage.getItem(_this.pageData.username)
              )
              if (!userData) {
                userData = {}
              }
              userData.new_price = response.data.data.new_price
              sessionStorage.setItem(
                _this.pageData.username,
                JSON.stringify(userData)
              )
              resolve(true)

              return
            } else {
              _this.$notify.error({
                title: _this.$t('App.notify.title_server'),
                message: _this.$t('App.notify.content_servererr'),
              })
              return
            }
          } else {
            _this.$notify.error({
              title: _this.$t('App.notify.title_server'),
              message: _this.$t('App.notify.content_server') + response.status,
            })
            return
          }
        })
        .catch((error) => {
          console.log(error, 12)

          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })
          return
        })
    })
  })
}
function getCartIndex(_this, username) {
  return new Promise((resolve, reject) => {
    let arr = []
    _this
      .$axios({
        method: 'post',
        // url: Vue.prototype.api + '6003/api/local/showCart',
        url: Vue.prototype.api + 'api/local/showCart',
        data: {
          username,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.code == '200') {
            let checkArr = Object.keys(response.data.data.cartMap)
            if (checkArr.length > 0) {
              for (let i in response.data.data.cartMap) {
                arr.push(response.data.data.cartMap[i])
              }

              arr.sort(compare('index'))
              _this.pageData.cartTableData = arr
              resolve(arr[arr.length - 1].index)
            } else {
              resolve(1)
            }

            return
          } else if (response.data.code == '210') {
            resolve(-1)
            return
          } else {
            _this.$notify.error({
              title: _this.$t('App.notify.title_server'),
              message: _this.$t('App.notify.content_servererr') + 'err-0',
            })
            return
          }
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message:
              _this.$t('App.notify.content_server') + response.status + 'err-1',
          })
          return
        }
      })
      .catch((error) => {
        console.log(error, 56)

        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_servererr') + 'err-2',
        })
        return
      })
  })
}

function airConditions(_this, cartList) {
  let airTotal = 0
  for (let item of cartList) {
    if (item.productid == 'PD830215946') {
      airTotal = airTotal + item.quantity
    }
    if (item.productid == 'PD8302305836') {
      airTotal = airTotal + item.quantity
    }
    if (item.productid == 'PD3486991625') {
      airTotal = airTotal + item.quantity
    }
    if (item.productid == 'PD3486995656') {
      airTotal = airTotal + item.quantity
    }
  }
  if (airTotal == 0 || airTotal % 30 == 0) {
    _this.pageData.airFlag = false
  } else {
    _this.pageData.airFlag = true
  }
}

async function showCart(_this, username) {
  await _this
    .$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/showCart',
      url: Vue.prototype.api + 'api/local/showCart',
      data: {
        username,
      },
    })
    .then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          let checkArr = Object.keys(response.data.data.cartMap)
          _this.pageData.cartTableData = []
          for (let i in response.data.data.cartMap) {
            _this.pageData.cartTableData.push(response.data.data.cartMap[i])
            _this.pageData.totalWeight =
              _this.pageData.totalWeight +
              response.data.data.cartMap[i].weight *
              response.data.data.cartMap[i].quantity
            _this.pageData.totalPrice =
              _this.pageData.totalPrice +
              Number(response.data.data.cartMap[i].subprice)
          }
          airConditions(_this, _this.pageData.cartTableData)

          for (let item of _this.pageData.cartTableData) {
            item.subprice = item.subprice.toFixed(2)
            item.uniprice = item.uniprice.toFixed(2)
            item.disprice = item.disprice.toFixed(2)
          }

          _this.pageData.cartTableData.sort(compare('index'))

          return _this.pageData.cartTableData
        } else if (response.data.code == '210') {
          return
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })
          return
        }
      } else {
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_server') + response.status,
        })
        return
      }
    })
    .catch((error) => {
      _this.$notify.error({
        title: _this.$t('App.notify.title_server'),
        message: _this.$t('App.notify.content_servererr'),
      })
      return
    })
}

//查询阶梯价格
export async function getLadderPrice(_this, productList, currency) {
  let productIdList =
    productList.map((it) => it.productid || it.product_id) || []

  _this
    .$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/stagedPrice/getInfo',
      url: Vue.prototype.api + 'api/local/stagedPrice/getInfo',
      data: productIdList,
    })
    .then((res) => {
      if (res.status == 200) {
        if (res.data.code == '200') {
          //阶梯数据
          let ladderData = {}
          let resData = res.data.data.filter((it) => it.currency == currency)

          resData.forEach((item) => {
            if (item.master_carton_qty && item.master_pack_qty) {
              ladderData[item.product_id] = [
                {
                  // title: '1pcs+',
                  title: 'Single Unit Price',
                  price: item.single_unit_price,
                },
                {
                  // title: item.master_pack_qty + 'pcs+',
                  title: 'MP Unit Price',
                  price: item.master_pack_price,
                },
                {
                  // title: item.master_carton_qty * item.master_pack_qty + 'pcs+',
                  title: 'MC Unit Price',
                  price: item.master_carton_price,
                },
              ]
            }
          })
          _this.pageData.ladderData = ladderData

          // 阶梯价格和节点显示
          productList.forEach((item) => {
            let data = getLadderPriceByProduct(
              resData.find(
                (op) => op.product_id == (item.productid || item.product_id)
              ) || {},
              item
            )

            //没有阶梯价格需要显示折扣价
            _this.$set(item, 'ladderPrice', item.disprice || item.uniprice)

            if (data) {
              _this.$set(
                item,
                'ladderPrice',
                data[0] || item.disprice || item.uniprice
              )
              _this.$set(item, 'stepActive', data[1])
              _this.$set(
                item,
                'subprice',
                (data[0] || item.uniprice) * item.quantity
              )
              _this.$set(
                item,
                'subtotal',
                (data[0] || item.subtotal / item.quantity) * item.quantity
              )
            }
          })

          _this.pageData.ladderDetailData = resData
        } else if (res.data.code == '210') {
          productList.forEach((item) => {
            //没有阶梯价格需要显示折扣价
            _this.$set(item, 'ladderPrice', item.disprice)
            _this.$set(item, 'subprice', item.disprice * item.quantity)
            _this.$set(item, 'subtotal', item.disprice * item.quantity)
          })
        }
      }
    })
}
export async function getLadderPriceNew(_this, productList, currency, username) {
  let productIdList =
    productList.map((it) => it.productid || it.product_id) || []

  _this
    .$axios({
      method: 'post',
      url: Vue.prototype.api + 'api/priceSystem/product/getPriceRuleResult',
      data: {
        custuser: { username: username },
        productIdList: productIdList
      },
    })
    .then((res) => {
      if (res.status == 200) {
        if (res.data.code == '200') {
          //阶梯数据
          let ladderData = {}
          let resData = res.data.data

          Object.entries(resData).forEach(([id, item]) => {
            if (item.stagedPrice) {
              ladderData[item.productId] = [
                {
                  title: 'Single Unit Price',
                  price: item.stagedPriceRule.singleUnitPrice,
                },
                {
                  title: 'MP Unit Price',
                  price: item.stagedPriceRule.masterPackPrice,
                },
                {
                  title: 'MC Unit Price',
                  price: item.stagedPriceRule.masterCartonPrice,
                },
              ]
            }

          })
          _this.pageData.ladderData = ladderData

          // 阶梯价格和节点显示
          productList.forEach((item) => {
            let priceData = resData[item.productid || item.product_id]
            _this.$set(
              item,
              'stagedPrice',
              priceData.stagedPrice
            )
            _this.$set(
              item,
              'finalDiscountPrice',
              priceData.finalDiscountPrice
            )
            _this.$set(
              item,
              'finalDiscountRate',
              priceData.finalDiscountRate
            )
            if (priceData.stagedPrice) {
              let data = getLadderPriceByProduct(
                priceData.stagedPriceRule || {},
                item
              )
              //没有阶梯价格需要显示折扣价
              _this.$set(item, 'ladderPrice', item.disprice || item.uniprice)


              if (data) {
                _this.$set(
                  item,
                  'ladderPrice',
                  data[0] || item.disprice || item.uniprice
                )
                _this.$set(item, 'stepActive', data[1])
                _this.$set(
                  item,
                  'subprice',
                  (data[0] || item.uniprice) * item.quantity
                )
                // _this.$set(
                //   item,
                //   'subtotal',
                //   (data[0] || item.subtotal / item.quantity) * item.quantity
                // )

                _this.pageData.ladderDetailData = resData
              }
            }
          })


        } else if (res.data.code == '210') {
          productList.forEach((item) => {
            //没有阶梯价格需要显示折扣价
            _this.$set(item, 'ladderPrice', item.disprice)
            _this.$set(item, 'subprice', item.disprice * item.quantity)
            _this.$set(item, 'subtotal', item.disprice * item.quantity)
          })
        }
      }
    })
}

//实时计算购物车中某产品对应的阶梯价格
export function getLadderPriceByProduct(ladderData, product) {
  if (
    !ladderData.masterPackQty ||
    !ladderData.masterCartonQty ||
    !product
  ) {
    return null
  }
  if (product.quantity < ladderData.masterPackQty) {
    return [ladderData.singleUnitPrice, 0]
  }
  if (
    product.quantity >= ladderData.masterPackQty &&
    product.quantity < ladderData.masterCartonQty
  ) {
    return [ladderData.masterPackPrice, 1]
  }
  if (product.quantity >= ladderData.masterCartonQty) {
    return [ladderData.masterCartonPrice, 2]
  }
}

//实时计算某一条的阶梯价和总价
export function getLadderPriceByProductAndQuantity(_this, row) {
  let ladder = _this.pageData.ladderDetailData[row.productid || row.product_id]

  let data = getLadderPriceByProduct(ladder.stagedPriceRule, row)
  console.log(ladder, data, row, 1)
  if (data) {
    row.ladderPrice = data[0] || row.uniprice || row.disprice || row.saleprice
    row.stepActive = data[1]
    row.subprice = (row.quantity * row.ladderPrice).toFixed(2)
    row.subtotal = (row.quantity * row.ladderPrice).toFixed(2)

    //更新最新的数量
    row.master_pack_qty = ladder.masterPackQty
    row.master_carton_qty = ladder.masterCartonQty

    return row
  }
}

function deleteFromCart(_this, user, cartitem) {
  _this
    .$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/deleteFromCart',
      url: Vue.prototype.api + 'api/local/deleteFromCart',
      data: {
        user,
        cartitem,
      },
    })
    .then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          airConditions(_this, _this.pageData.cartTableData)
          _this.pageData.totalPrice =
            _this.pageData.totalPrice - cartitem.subprice
          _this.pageData.totalWeight =
            _this.pageData.totalWeight - cartitem.weight * cartitem.quantity
          return
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })
          return
        }
      } else {
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_server') + response.status,
        })
        return
      }
    })
    .catch((error) => {
      _this.$notify.error({
        title: _this.$t('App.notify.title_server'),
        message: _this.$t('App.notify.content_servererr'),
      })
      return
    })
}

function modifyQuantityFromCart(_this, user, cartitem, quantityChange) {
  cartitem.disprice = cartitem.ladderPrice || cartitem.disprice
  _this
    .$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/modifyQuantityFromCart',
      url: Vue.prototype.api + 'api/local/modifyQuantityFromCart',
      data: {
        user,
        cartitem,
      },
    })
    .then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          airConditions(_this, _this.pageData.cartTableData)

          //原代码
          // _this.pageData.totalPrice =
          //   _this.pageData.totalPrice + cartitem.disprice * quantityChange
          // _this.pageData.totalWeight =
          //   _this.pageData.totalWeight + cartitem.weight * quantityChange

          //如果是新价格，需要重新计算总计
          // if (_this.pageData.custUserinfo.new_price) {
          const { totalPrice, totalWeight } =
            _this.pageData.cartTableData.reduce(
              (acc, item) => {
                acc.totalPrice += Number(item.subprice || 0)
                acc.totalWeight += Number(item.weight) * Number(item.quantity)
                return acc
              },
              { totalPrice: 0, totalWeight: 0 }
            )

          _this.pageData.totalPrice = totalPrice
          _this.pageData.totalWeight = totalWeight

          // }

          _this.pageData.currentClickId = null
          _this.pageData.oldRow = null
          return
        } else if (response.data.code == '600') {
          _this.$notify.error({
            title: _this.$t('App.notify.title_warning'),
            message: _this.$t('App.notify.content_illegal'),
          })
          return
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })
          return
        }
      } else {
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_server') + response.status,
        })
        return
      }
    })
    .catch((error) => {
      _this.$notify.error({
        title: _this.$t('App.notify.title_server'),
        message: _this.$t('App.notify.content_servererr'),
      })
      return
    })
}

function clearCart(_this, username) {
  _this
    .$axios({
      method: 'post',
      // url: Vue.prototype.api + '6003/api/local/clearCart',
      url: Vue.prototype.api + 'api/local/clearCart',
      data: {
        username,
      },
    })
    .then((response) => {
      if (response.status == 200) {
        if (response.data.code == '200') {
          return
        } else {
          _this.$notify.error({
            title: _this.$t('App.notify.title_server'),
            message: _this.$t('App.notify.content_servererr'),
          })
          return
        }
      } else {
        _this.$notify.error({
          title: _this.$t('App.notify.title_server'),
          message: _this.$t('App.notify.content_server') + response.status,
        })
        return
      }
    })
    .catch((error) => {
      _this.$notify.error({
        title: _this.$t('App.notify.title_server'),
        message: _this.$t('App.notify.content_servererr'),
      })
      return
    })
}

function compare(property) {
  return function (a, b) {
    var value1 = a[property]
    var value2 = b[property]
    return value1 - value2
  }
}

import { async } from 'regenerator-runtime'
import Vue from 'vue'

export {
  addToCart,
  showCart,
  deleteFromCart,
  modifyQuantityFromCart,
  clearCart,
}



// WEBPACK FOOTER //
// ./src/assets/js/cart.js